import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { userClient } from '../client/userClient';


export type Params = Users.GetPreferenceHistoryParams;

type Options = {
  retry?: boolean;
};

const defaultOptions: Partial<Options> = {
  retry: false,
};

export const useUserPreferenceHistory = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getPreferenceHistory, params],
    queryFn: () => userClient.getPreferenceHistory(params),
    retry: options.retry !== undefined ? options.retry : defaultOptions.retry,
  });

  return {
    ...rest,
    count: data?.count || 0,
    preferenceHistory: data?.results || [],
  };
};
